import React from 'react';
import { TabList } from '@mui/lab';
import _ from 'lodash';
import { Tab } from '@mui/material';
import theme, { TMaterialStyleItem, TMaterialStyles } from '../../theme';

export type TTab = {
  label: string;
  value: string;
};

interface ICustomTabs {
  tabs: TTab[];
  onChange: (event: any, value: string) => void;
  sx?: TMaterialStyleItem;
}

export const CustomTabs: React.FC<ICustomTabs> = ({ tabs, onChange, sx }) => {
  return (
    <TabList
      onChange={onChange}
      sx={[materialStyles.tabListContainer, sx || null]}
    >
      {_.map(tabs, (tab) => (
        <Tab
          sx={materialStyles.tabContainer}
          key={tab.label}
          label={tab.label}
          value={tab.value}
        />
      ))}
    </TabList>
  );
};

const materialStyles: TMaterialStyles = {
  tabListContainer: {
    backgroundColor: theme.palette.secondary.main,
    boxShadow: `0px 4px 0px ${theme.palette.secondary.dark}`,
    borderRadius: '14px',
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tabContainer: {
    flex: 1,
    color: theme.palette.primary.contrastText,
    fontWeight: 600,
    letterSpacing: 0,
    fontSize: '18px',
    lineHeight: '100%',
    textShadow: `0px 2px 0px ${theme.palette.secondary.contrastText}`,

    '&.Mui-selected': {
      color: `white !important`,
      backgroundColor: theme.palette.primary.main,
      borderRadius: '14px',
      textShadow: `0px 2px 0px ${theme.palette.secondary.main}`,
    },
  },
};
